<template>
  <div class="advance-image-swiper">
    <swiper
      :class="!isMobile() && 'swiper-no-swiping'"
      ref="img-swiper"
      :options="swiperOptions"
    >
      <swiper-slide
        v-for="(item, index) in $attrs.dataList"
        :key="index"
      >
        <img
          class="img"
          :src="item.url"
          @click.prevent="openUrl(item.link)"
          :style="{
            cursor: item.link ? 'pointer' : 'auto',
            '--imgWidth': imgConf.width,
            borderRadius: transfCssArrayConfig(item.borderRadius),
          }"
        />
      </swiper-slide>
      <div
        v-if="pagination.is"
        class="swiper-pagination"
        slot="pagination"
        :style="{
          '--activePageColor': pagination.curColor,
          '--comPageColor': pagination.comColor
        }"
      ></div>
    </swiper>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { isMobile } from '../../utils/index'
import merge from 'lodash/merge'
import mixin from '../../utils/mixin'
import { arrToPx, pxToRem } from '../../utils/index'

export default {
  props: ['option'],
  mixins: [mixin],
  data () {
    return {
      swiperOptions: {},
      isMobile
    }
  },
  computed: {
    swiper () {
      return this.$refs['img-swiper'].swiper
    },
    imgConf () {
      return this.$attrs.imgConf
    },
    pagination () {
      return this.$attrs.pagination
    }
  },
  created () {
    this.initOptions()
  },
  methods: {
    transfCssArrayConfig (arrayConfig = []) {
      return pxToRem(arrToPx(arrayConfig))
    },

    initOptions () {
      const option = this.option
      if (!option.autoplay.is) {
        option.autoplay = false
      }
      this.swiperOptions = merge({
        slidesPerColumnFill: 'column',
        slidesPerView: 1,
        slidesPerGroup: 1,
        slidesPerColumn: 1,
        autoplayDisableOnInteraction: false,
        observer: true,
        observeParents: true,
        grabCursor: false,
        noSwiping: true,
        lazy: true,
        loop: true
      }, option)
    }
  },
  watch: {
    option (val) {
      this.$nextTick(() => {
        if (this.swiper) {
          this.swiper.params = merge(this.swiper.params, val)
          this.swiper.update()
        }
      })
    },
    'option.autoplay.is': {
      handler (val) {
        if (val) {
          this.swiper.autoplay.start()
          this.swiper.loopCreate()
        } else {
          this.swiper.autoplay.stop()
          this.swiper.loopDestroy()
        }
      },
      immeidate: true,
      deep: true
    }
  },
  components: {
    swiper,
    swiperSlide
  }
}
</script>
<style lang="stylus" scoped>
.advance-image-swiper
  /deep/.swiper-pagination-bullet
    width 30px
    height 2px
    background-color var(--comPageColor)
  /deep/.swiper-pagination-bullet-active
    background-color var(--activePageColor)
  .img
    display block
    margin 0 auto
    width var(--imgWidth)
</style>
